import {
  Component,
  OnDestroy,
  ElementRef,
  ViewEncapsulation,
  TemplateRef,
  ContentChild,
  HostListener,
  HostBinding,
  DestroyRef,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { pagesToggleService } from '../../services/toggler.service';
declare let pg: any;

@Component({
  selector: 'pg-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  host: {
    class: 'page-sidebar',
  },
  encapsulation: ViewEncapsulation.None,
})
export class SidebarComponent implements OnDestroy {
  private destroyRef = inject(DestroyRef);
  pin = false;
  drawer = false;
  sidebar;
  timer;
  @HostBinding('style.transform')
    style: string;

  private sideBarWidth = 280;
  private sideBarWidthCondensed = 280 - 70;

  @ContentChild('sideBarOverlay', { static: true }) sideBarOverlay: TemplateRef<void>;
  @ContentChild('sideBarHeader', { static: true }) sideBarHeader: TemplateRef<void>;
  @ContentChild('menuItems', { static: true }) menuItems: TemplateRef<void>;

  constructor(private appSidebar: ElementRef, private toggler: pagesToggleService) {
    this.toggler.sideBarToggle.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(toggle => {
      this.toggleMobile(toggle);
    });
    this.toggler.pageContainerHover.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(message => {
      this.closeSideBar();
    });
    this.toggler.menuDrawer.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(message => {
      this.toggleDrawer();
    });
    this.mobileSidebar = false;
  }

  ngOnDestroy() {
    clearTimeout(this.timer);
  }
  @HostBinding('class.visible') mobileSidebar: boolean;

  @HostListener('mouseenter', ['$event'])
  @HostListener('click', ['$event'])
  openSideBar() {
    if (pg.isVisibleSm() || pg.isVisibleXs()) {
      return false;
    }
    if (this.pin) {
      return false;
    }

    this.style = 'translate3d(' + this.sideBarWidthCondensed + 'px, 0,0)';
    pg.addClass(document.body, 'sidebar-visible');
  }

  closeSideBar() {
    if (pg.isVisibleSm() || pg.isVisibleXs()) {
      return false;
    }
    if (this.pin) {
      return false;
    }
    this.style = 'translate3d(0,0,0)';
    pg.removeClass(document.body, 'sidebar-visible');
    // this.drawer = false;
  }

  toggleMenuPin() {
    if (this.pin) {
      this.pin = false;
    }
    else {
      this.pin = true;
    }
  }

  toggleDrawer() {
    if (this.drawer) {
      this.drawer = false;
    }
    else {
      this.drawer = true;
    }
  }

  toggleMobile(toggle: boolean) {
    clearTimeout(this.timer);
    if (toggle) {
      this.mobileSidebar = toggle;
    }
    else {
      this.timer = setTimeout(() => {
        this.mobileSidebar = toggle;
      }, 400);
    }
  }
}
